import React, { useEffect } from 'react';
import { ContentContainer } from '../ContentContainer';
import { ReviewSummary } from './components/ReviewSummary';
import { ReviewList } from './components/ReviewList';
import type { ReviewTabProps } from './types/ReviewTabProps';
import { Divider, Flex, PrimaryButton, VerticalSpacing } from '@banhala/ui-kit';
import { useAppDownloadModal } from 'shared/src/hooks';

export const ReviewTab: React.FC<ReviewTabProps> = props => {
  const [summaryHeight, setSummaryHeight] = React.useState(0);
  const [listHeight, setListHeight] = React.useState(100);
  const [tabHeight, setTabHeight] = React.useState(0);
  const { show: openModal } = useAppDownloadModal();

  useEffect(() => {
    const targetHeight = summaryHeight + listHeight;
    if (tabHeight !== targetHeight) {
      props.onChangeTabHeight(targetHeight);
      setTabHeight(targetHeight);
    }
  }, [summaryHeight, listHeight, tabHeight, props]);

  return (
    <ContentContainer focused={props.focused}>
      <Flex
        onLayout={({ nativeEvent }) => {
          setSummaryHeight(nativeEvent.layout.height);
        }}
      >
        <ReviewSummary />
        <Divider size={'medium'} />
      </Flex>
      <Flex
        onLayout={({ nativeEvent }) => {
          setListHeight(nativeEvent.layout.height);
        }}
      >
        <ReviewList />
        <Flex padding={{ horizontal: 14 }}>
          <PrimaryButton
            variant={'fill'}
            size={'medium'}
            outline
            onPress={() => {
              openModal();
            }}
          >
            앱에서 리뷰 전체보기
          </PrimaryButton>
        </Flex>
        <VerticalSpacing size={36 + 20} />
      </Flex>

    </ContentContainer>
  );
};
